// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__39Cd2","info":"UpdateTermsInfo_info__BVxw3"};